export default "assets/mec-logo.svg"